export const SlackConnectForm = [
    {
      label: "Slack OAuth Key",
      name: "oauthToken", 
      rules: [
        {
          required: true,
          message: "Please input OAuth Key!",
        },
      ],
    },
    {
      label: "Slack Member ID",
      name: "memberId", 
      rules: [
        {
          required: true,
          message: "Please input Member ID!",
        },
      ],
    },
  ];